import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createBlock(_component_el_form_item, {
    prop: "stage",
    label: _ctx.label
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_select, {
        "model-value": _ctx.modelValue,
        onChange: _ctx.setValue,
        placeholder: "Startup Stage: ex: MVP",
        "w-100": ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stages, (ind) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              value: ind,
              label: ind,
              key: `${ind}-ind`
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_space, null, {
                  default: _withCtx(() => [
                    _cache[0] || (_cache[0] = _createElementVNode("i", { class: "App-Loc-Icon el-icon-business" }, null, -1)),
                    _createElementVNode("span", null, _toDisplayString(ind), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["value", "label"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["model-value", "onChange"])
    ]),
    _: 1
  }, 8, ["label"]))
}